import { typedMemo } from "src/types"
import { Formik } from "src/types/formik"
import { FormikMainInsuredGroup } from "src/types/formik/group.types"
import { useEntryGroupStep2 } from "./entry-group-step2.hook"
import { Tooltip } from "src/widgets/tooltip/tooltip"
import { InputUploadFile } from "src/widgets/input-upload-file/input-upload-file"
import { Button } from "src/widgets/button/button"
import { Trans } from "react-i18next"
import { InputText } from "src/widgets/input-text/input-text"
import { InputRadio } from "src/widgets/input-radio/input-radio"
import { ChangeEvent } from "react"
import { InputDate } from "src/widgets/input-date/input-date"
import { Image, Modal } from "react-component-library";
import { AlertCircleIcon, EditIcon } from "src/assets"
import ScrollToTop from "src/widgets/scroll-to-top/scroll-to-top"

export const EntryGroupStep2 = typedMemo(
	({ formikFather }: { formikFather: Formik<FormikMainInsuredGroup> }) => {
		const {
			t,
			filesGroup,
			formikModal,
			genderOptions,
			isModalVisible,
			validationSchema,
			fcQuestionOptions,
			nationalityOptions,
			hideModal,
			onRemoveFile,
			setFilesGroup,
			onDownloadFile,
			onShowModalEditPerson,
		} = useEntryGroupStep2({ formikFather })

		const { fileNames, fileStatus, group } = formikFather.values

		const {
			values,
			errors,
			touched,
			handleBlur,
			handleChange,
			setFieldValue,
			setFieldTouched,
			handleSubmit,
		} = formikModal

		const Title = (
			<div className="col-12 col-md-6 p-0 px-md-3 pl-md-3 mb-2 mb-md-1 font-20-bold">
				{t('entry_group_step_2.title')}
			</div>
		)

		const UploadInfo = (
			<div className="col-12 col-md-6 p-0 px-md-3 pl-md-3 mb-2 mb-md-1">
				<div className="font-14-semibold me-4">{t('entry_group_step_2.upload_file_title')}</div>
				<div className="d-flex align-items-center">
					<div className="font-14-semibold me-4">{t('entry_group_step_2.upload_file_title_1')}</div>
					<Tooltip placement="top" icon_size={15}>
						<div className="font-14 c-292929 d-flex flex-column align-items-start">
							<div>{t('entry_group_step_2.tooltip_info_file_1')}</div>
							<div>{t('entry_group_step_2.tooltip_info_file_2')}</div>
						</div>
					</Tooltip>
				</div>
			</div>
		)

		const Upload = (
			<div className="d-flex align-items-center justify-content-center px-md-3 mt-4 mb-md-4">
				<div className="col-md-6">
					<InputUploadFile
						selectedFiles={filesGroup}
						onFilesSelected={setFilesGroup}
						onRemove={onRemoveFile}
						selectedFilesNames={fileNames}
						fileStatus={fileStatus}
						multiple={false}
						showAlert={true}
					/>
				</div>
			</div>
		)

		const GroupInfoDesktop = (
			<div className="d-flex align-items-center justify-content-center px-md-3 mt-4 mb-4">
				<div className="col-md-12">
					<div className="d-flex align-items-center">
						<div className="font-14">{t('entry_group_step_2.group_number_1')}</div>
						<div className="font-14-bold ms-2">
							{group?.length}
							{t('entry_group_step_2.group_number_2')}
						</div>
					</div>
					<div className="mt-3 mb-3 border-top" />
					<div className="col-md-12 d-flex align-items-center mb-4">
						<div className="font-14-semibold col-md-4 text-uppercase c-7f7f7f">
							{t('entry_group_step_2.group_column_1')}
						</div>
						<div className="font-14-semibold col-md-3 text-uppercase c-7f7f7f">
							{t('entry_group_step_2.group_column_2')}
						</div>
						<div className="font-14-semibold col-md-3 text-uppercase c-7f7f7f">
							{t('entry_group_step_2.group_column_3')}
						</div>

						<div className="col-md-2" />
					</div>
					{group?.map((group, index) => (
						<div key={index}>
							<div className="col-md-12 d-flex align-items-center">
								<div className="font-15 col-md-4">
									{group?.name} {group?.surname}
								</div>
								<div className="font-15 col-md-3">
									{group?.birthPlace && group?.birthDate ? (
										<div>
											{group?.birthPlace}, {group?.birthDate}
										</div>
									) : (
										<div>-</div>
									)}
								</div>
								<div className="font-15 col-md-3">
									{group?.fiscalCode ? <div>{group?.fiscalCode}</div> : <div>-</div>}
								</div>
								{group?.errors && (
									<div className="font-15 col-md-2 d-flex align-items-center justify-content-center">
										<Image
											src={EditIcon}
											width={20}
											height={20}
											className="ms-md-3 cursor-pointer"
											onClick={() => onShowModalEditPerson(group?.id)}
										/>
										<Image
											src={AlertCircleIcon}
											width={20}
											height={20}
											className="ms-md-3 filter-A90433"
										/>
									</div>
								)}
							</div>
							<div className="mt-2 mb-2 border-top" />
						</div>
					))}
				</div>
			</div>
		)

		const GroupInfoMobile = (
			<div className="d-flex align-items-center justify-content-center px-md-3 mt-4 mb-4">
				<div className="col-md-12">
					<div className="d-flex align-items-center">
						<div className="font-14">{t('entry_group_step_2.group_number_1')}</div>
						<div className="font-14-bold ms-2">
							{group?.length}
							{t('entry_group_step_2.group_number_2')}
						</div>
					</div>
					<div className="mt-3 mb-3 border-top" />
					<div className="col-md-12 d-flex align-items-center">
						<div className="col-md-2" />
					</div>
					{group?.map((groupItem, index) => (
						<div key={index} onClick={() => onShowModalEditPerson(groupItem?.id)}>
							<div className={`p-3 ${groupItem?.errors ? 'border-error' : ''}`}>
								<div className="d-flex align-items-center col-12 mb-2">
									<div className="font-15-semibold col-6 c-7f7f7f pe-4">
										{t('entry_group_step_2.group_column_1')}
									</div>
									<div className="font-15 col-6">
										{groupItem?.name} {groupItem?.surname}
									</div>
								</div>

								<div className="d-flex align-items-center col-12 mb-2">
									<div className="font-15-semibold col-6 c-7f7f7f pe-4">
										{t('entry_group_step_2.group_column_2')}
									</div>
									<div className="font-15 col-6">
										{groupItem?.birthPlace && groupItem?.birthDate ? (
											<div>
												{groupItem?.birthPlace}, {groupItem?.birthDate}
											</div>
										) : (
											<div>-</div>
										)}
									</div>
								</div>

								<div className="d-flex align-items-center col-12">
									<div className="font-15-semibold col-6 c-7f7f7f pe-4">
										{t('entry_group_step_2.group_column_3')}
									</div>
									<div className="font-15 col-6">
										{groupItem?.fiscalCode ? <div>{groupItem?.fiscalCode}</div> : <div>-</div>}
									</div>
								</div>
							</div>
							{index !== group?.length - 1 && <div className="mt-2 mb-2 border-top" />}
						</div>
					))}
				</div>
			</div>
		)

		const InfoBox = (
			<div className="d-flex flex-column justify-content-center px-md-3 mt-4 mb-md-4">
				<div className="font-20-semibold me-4">{t('entry_group_step_2.group_info_title')}</div>
				<div className="d-flex flex-column flex-md-row flex-wrap gap-3 gap-md-5 mt-4">
					<div className="col flex-grow-1 flex-md-grow-3 p-4 info-box d-flex flex-column justify-content-between">
						<div>
							<div className="font-20 group-square col-1">1</div>
							<div className="font-16-semibold my-3">{t('entry_group_step_2.group_info_step_1_title')}</div>
							<div className="d-inline-block mb-3">
								<div className="py-md-2 font-14 display-contents">
									{t('entry_group_step_2.group_info_step_1')}
								</div>
							</div>
						</div>
						<div className="d-none d-md-block py-md-2 display-contents cursor-pointer">
							<Button
								flavor="downloadAccent"
								text={t('entry_group_step_2.group_info_step_1_here')}
								classes="bg-b2dcd5 w-100 download-btn d-flex align-items-center justify-content-center"
								classesText="font-15-semibold"
								onPress={() => onDownloadFile()}
							/>
						</div>
						<div className="d-block d-md-none py-md-2 display-contents cursor-pointer">
							<Button
								flavor="downloadAccent"
								text={t('entry_group_step_2.group_info_step_1_here')}
								classes="bg-b2dcd5 w-100 download-btn d-flex align-items-center justify-content-center"
								classesText="font-13-semibold"
								onPress={() => onDownloadFile()}
							/>
						</div>
					</div>
					<div className="col flex-grow-1 flex-md-grow-3 p-4 info-box second-box">
						<div className="font-20 group-square col-1">2</div>
						<div className="font-16-semibold my-3">{t('entry_group_step_2.group_info_step_2_title')}</div>
						<div className="font-14 my-3">{t('entry_group_step_2.group_info_step_2')}</div>
					</div>
					<div className="col flex-grow-1 flex-md-grow-3 p-4 info-box">
						<div className="font-20 group-square col-1">3</div>
						<div className="font-16-semibold my-3">{t('entry_group_step_2.group_info_step_3_title')}</div>
						<div className="font-14 my-3">
							<Trans i18nKey="entry_group_step_2.group_info_step_3" />
							<ul>
								<li>{t('entry_group_step_2.group_info_step_3_bullet_1')}</li>
								<li>{t('entry_group_step_2.group_info_step_3_bullet_2')}</li>
								<li>{t('entry_group_step_2.group_info_step_3_bullet_3')}</li>
								<li>
									<Trans i18nKey="entry_group_step_2.group_info_step_3_bullet_4" />
								</li>
								<li>
									<Trans i18nKey="entry_group_step_2.group_info_step_3_bullet_5" />
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		)

		const ModalEditPerson = (
			<Modal visible={isModalVisible} on_close={() => hideModal()}>
				<>
					<div className="font-16-semibold pb-3 col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
						{t('entry_group_step_2.modal_edit_title')}
					</div>
					<form onSubmit={handleSubmit} className="row justify-content-center m-0 p-0">
						<div>
							<div
								className={`${!touched.name || !errors.name ? 'pb-3' : ''
									} col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3`}
							>
								<InputText
									name="name"
									handleChange={handleChange}
									handleBlur={handleBlur}
									validationSchema={validationSchema}
									touched={true}
									value={values.name}
									error={touched.name && errors.name ? errors.name : ''}
									label={t('data_entry_step_2.insured_name')}
									placeholder={t('data_entry_step_2.insured_name_placeholder')}
								/>
							</div>

							<div
								className={`${!touched.surname || !errors.surname ? 'pb-3' : ''
									} col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3`}
							>
								<InputText
									name="surname"
									handleChange={handleChange}
									handleBlur={handleBlur}
									validationSchema={validationSchema}
									touched={true}
									value={values.surname}
									error={touched.surname && errors.surname ? errors.surname : ''}
									label={t('data_entry_step_2.insured_surname')}
									placeholder={t('data_entry_step_2.insured_surname_placeholder')}
								/>
							</div>

							<div className="d-block d-md-flex">
								<div className="col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
									<InputRadio
										name="nationality"
										handleChange={handleChange}
										handleBlur={handleBlur}
										options={nationalityOptions}
										validationSchema={validationSchema}
										touched={true}
										value={values.nationality}
										error={errors.nationality}
										label={t('data_entry_step_2.insured_nationality')}
										classes="m-0 p-0"
										classesLabel="m-0 p-0 font-16 d-flex align-items-center mb-3"
									/>
								</div>
							</div>

							<div className="d-block d-md-flex">
								<div className="col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
									<InputRadio
										name="fiscalCodeQuestion"
										handleChange={(event: ChangeEvent<HTMLInputElement>) => {
											handleChange(event)
											if (event?.target?.value === 'no_id') {
												setFieldValue('fiscalCode', '')
											} else if (event?.target?.value === 'yes_id') {
												setFieldValue('birthDate', '')
												setFieldValue('birthNation', '')
												setFieldValue('birthPlace', '')
												setFieldValue('gender', '')
											}
										}}
										handleBlur={handleBlur}
										options={fcQuestionOptions}
										validationSchema={validationSchema}
										touched={true}
										value={values.fiscalCodeQuestion}
										error={
											errors.fiscalCodeQuestion && touched.fiscalCodeQuestion
												? errors.fiscalCodeQuestion
												: ''
										}
										label={t('data_entry_step_2.insured_fc_question')}
										classesLabel="m-0 p-0 font-16 d-flex align-items-center mb-3"
										classes="m-0 p-0 mb-3"
									/>
								</div>
							</div>

							{values.fiscalCodeQuestion === 'yes_id' && (
								<div className="d-block d-md-flex">
									<div className="col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
										<InputText
											name="fiscalCode"
											handleChange={handleChange}
											handleBlur={handleBlur}
											validationSchema={validationSchema}
											touched={true}
											value={values.fiscalCode?.toUpperCase()}
											error={errors.fiscalCode}
											label={`${t('data_entry_step_2.insured_fc')}*`}
											placeholder={t('data_entry_step_2.insured_fc_placeholder')}
										/>
									</div>
								</div>
							)}

							{values.fiscalCodeQuestion === 'no_id' && (
								<div>
									<div className="d-block d-md-flex">
										<div className="col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
											<InputDate
												name="birthDate"
												handleChange={handleChange}
												handleBlur={handleBlur}
												setFieldValue={setFieldValue}
												setFieldTouched={setFieldTouched}
												validationSchema={validationSchema}
												touched={true}
												value={values.birthDate}
												error={errors.birthDate}
												label={`${t('data_entry_step_2.insured_birth')}*`}
												placeholder={t('data_entry_step_2.insured_birth_placeholder')}
												disabledTo={new Date()}
												classes="m-0 p-0"
											/>
										</div>

										<div className="col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
											<InputText
												name="birthNation"
												handleChange={handleChange}
												handleBlur={handleBlur}
												validationSchema={validationSchema}
												touched={true}
												value={values.birthNation}
												error={errors.birthNation}
												label={`${t('data_entry_step_2.insured_birth_nation')}*`}
												placeholder={t('data_entry_step_2.insured_birth_nation_placeholder')}
											/>
										</div>
									</div>

									<div className="d-block d-md-flex">
										<div className="col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
											<InputText
												name="birthPlace"
												handleChange={handleChange}
												handleBlur={handleBlur}
												validationSchema={validationSchema}
												touched={true}
												value={values.birthPlace}
												error={errors.birthPlace}
												label={`${t('data_entry_step_2.insured_birth_place')}*`}
												placeholder={t('data_entry_step_2.insured_birth_place_placeholder')}
											/>
										</div>

										<div className="col-sm-12 col-md-6 p-0 px-md-3 pl-md-3 pr-md-3">
											<InputRadio
												name="gender"
												handleChange={handleChange}
												handleBlur={handleBlur}
												options={genderOptions}
												validationSchema={validationSchema}
												touched={true}
												value={values.gender}
												error={errors.gender}
												label={`${t('data_entry_step_2.insured_gender')}*`}
												classesLabel="m-0 p-0 font-16 d-flex align-items-center mb-3"
												classes="m-0 p-0 mb-3"
											/>
										</div>
									</div>
								</div>
							)}
							<div className="col-sm-12 p-0 px-md-3 pl-md-3 pr-md-3 d-flex align-items-center justify-content-center">
								<Button
									text={t('commons.confirm')}
									flavor="accent"
									type="submit"
									classes="mt-4 pt-2 pb-2 ps-3 pe-3 d-flex align-items-center"
									classesText="font-15-semibold"
									classesIconRight="ms-2"
								/>
							</div>
						</div>
					</form>
				</>
			</Modal>
		)

		return (
			<div>
				<ScrollToTop />
				{Title}
				{UploadInfo}
				{Upload}
				{group?.length > 0 && (
					<div>
						<div className="d-none d-md-block">{GroupInfoDesktop}</div>
						<div className="d-block d-md-none">{GroupInfoMobile}</div>
					</div>
				)}
				{ModalEditPerson}
				{InfoBox}
			</div>
		)
	}
)
